<template>
    <div class="create-account-component">
        <div class="login-header">
            <div><img class="medium-logo" src="../assets/DineSafeSquare.png"/></div>
            <div class="title dinesafe-purple">DineSafeVT</div>
            <div class=" dinesafe-label">Reactive your account</div>
        </div>
        <div class='back-button'>
            <DxButton 
                icon="back"
                ref="btnBackRef" 
                type="normal"
                text="Back to Login"
                styling-mode="text" 
                @click="btnBackToLogin"               
            />
        </div>   

        <div ref="ProductInfoRef">
            <p>You are reactivating your DineSafeVT Subscription</p>
            <p><b>Cost: $99.00 per month</b></p>
            <p>Select a payment option, and your subscription will be activated</p>
            <p>You may cancel at any time</p>
        </div>

        <PaymentOptions
            ref="paymentOptionsRef"
            :accountInfo="null"
        />
    </div>
</template>
 
<script>
    import DxTextBox from "devextreme-vue/text-box";
    import {DxButton} from 'devextreme-vue';
    import DxValidationGroup from "devextreme-vue/validation-group";
    import DxValidator, { DxEmailRule, DxRequiredRule } from "devextreme-vue/validator";
    import DxValidationSummary from 'devextreme-vue/validation-summary';
    import PaymentOptions from "../../src/components/payment-options";

    export default {
        components: {
            DxTextBox,
            DxButton,
            DxValidationGroup,
            DxValidator,
            DxRequiredRule,
            DxValidationSummary,
            DxEmailRule,
            PaymentOptions,
        },
        props: {
            
        },
        data() {
            return {                
                //emailSentVisible: false,
                //successPopupVisible: false,
                
                /*accountInfo:[
                {
                    FirstName: null,
                    LastName: null,
                    Email: null,
                    Password: null,
                    ConfirmPassword: null,
                    BusinessName: null,
                    BusinessDesc: null,
                    PhoneNumber: null,
                    StreetAddress: null,
                    StateProvince: 'VT',
                    PostalCode: null,
                }]*/
                accountId: null,
                accountInfo: null,
            }
        },
        created(){
            //Get the Account Information
            this.$http.post(this.$store.state.appSettings.webServiceUrl + 'GetAccountData',
            {       
                //AccountId: this.$store.state.data.currentAccountId,
                AccountId: localStorage.dinesafeAccountId,
            }
            ).then(function(data){         
                if(data.body != null && data.body != ''){
                    var responseData = JSON.parse(data.body);      

                    this.accountInfo = responseData[0];       
                    
                    //Mark this as a resubscribe
                    this.accountInfo.Resubscribe = true;

                    //this.accountInfo.AccountId = this.$store.state.data.currentAccountId;
                    this.accountInfo.AccountId = localStorage.dinesafeAccountId;

                    //Store the AdminInfo to LocalStorage
                    localStorage.dinesafeData = JSON.stringify(this.accountInfo);
                }
            });                   
        },
        methods:{
            btnBackToLogin(e){
                //Navigate to the Login page
                this.$router.push("/login-form");
            }
        }
    }
</script>

<style scoped>
    

    .back-button{
        display: flex; 
        justify-content: center;
        padding-top: 10px;
        padding-bottom: 30px;
    }
</style>